// extracted by mini-css-extract-plugin
module.exports = {"segment":"segment-_EQEf","label":"label-3CUU7"};